export default __webpack_public_path__ + "static/media/bra.3b4ab9d0.svg";